import { render, staticRenderFns } from "./CommissionHeader.vue?vue&type=template&id=5b3156e9&scoped=true&"
import script from "./CommissionHeader.vue?vue&type=script&lang=js&"
export * from "./CommissionHeader.vue?vue&type=script&lang=js&"
import style0 from "./CommissionHeader.vue?vue&type=style&index=0&id=5b3156e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3156e9",
  null
  
)

export default component.exports